import { createSelector } from 'reselect';

const getContactInformation = (state) => state.contactInformation;

const contactInformationSelector = createSelector(
    [getContactInformation], (contactInformation) => contactInformation.toJS()
);

export default contactInformationSelector;
